import { formatTableData, getData } from '../utils/formatters';

// Define the type for Decatur GIS data based on the deserializer
interface DecaturData {
  address?: string;
  unit?: string;
  city?: string;
  zip?: string;
  lot?: string;
  parcelId?: string;
  ownerName?: string;
  ownerStreetAddress?: string;
  ownerCity?: string;
  ownerState?: string;
  ownerZip?: string;
  subdivisionName?: string;
  schoolDistrict?: string;
  taxDistrict?: string;
  neighborhood?: string;
  localDistrict?: string;
  stateDistrict?: string;
  districtName?: string;
  acres?: number;
  deedType?: string;
  zoningCode?: string;
  mapLink?: string;
  propertyCardLink?: string;
  taxBillLink?: string;
  imageLink?: string;
}

const DECATUR_ROWS = [
  {
    label: 'Address',
    getValue: (data: DecaturData) => getData(data, 'address', 'No address available')
  },
  {
    label: 'Zone',
    getValue: (data: DecaturData) => getData(data, 'zoningCode', 'No unit available')
  },

  {
    label: 'Unit',
    getValue: (data: DecaturData) => getData(data, 'unit', 'No unit available')
  },
  {
    label: 'City, Zip',
    getValue: (data: DecaturData) => `${getData(data, 'city', 'N/A')}, ${getData(data, 'zip', 'N/A')}`
  },
  {
    label: 'Lot Number',
    getValue: (data: DecaturData) => getData(data, 'lot', 'No lot number available')
  },
  {
    label: 'Subdivision',
    getValue: (data: DecaturData) => getData(data, 'subdivisionName', 'No subdivision information available')
  },
  {
    label: 'Parcel ID',
    getValue: (data: DecaturData) => getData(data, 'parcelId', 'No parcel ID available')
  },
  {
    label: 'Owner Information',
    getValue: (data: DecaturData) => {
      if (data?.ownerName || data?.ownerStreetAddress) {
        return `${getData(data, 'ownerName', 'N/A')}, ${getData(data, 'ownerStreetAddress', 'N/A')}, ${getData(data, 'ownerCity', 'N/A')}, ${getData(data, 'ownerState', 'N/A')} ${getData(data, 'ownerZip', 'N/A')}`;
      }
      return 'No owner information available';
    }
  },
  {
    label: 'School District',
    getValue: (data: DecaturData) => getData(data, 'schoolDistrict', 'No school district available')
  },
  {
    label: 'Tax District',
    getValue: (data: DecaturData) => getData(data, 'taxDistrict', 'No tax district available')
  },
  {
    label: 'Neighborhood',
    getValue: (data: DecaturData) => getData(data, 'neighborhood', 'No neighborhood information available')
  },
  {
    label: 'Local District',
    getValue: (data: DecaturData) => getData(data, 'localDistrict', 'No local district available')
  },
  {
    label: 'State District',
    getValue: (data: DecaturData) => getData(data, 'stateDistrict', 'No state district available')
  },
  {
    label: 'District Name',
    getValue: (data: DecaturData) => getData(data, 'districtName', 'No district name available')
  },
  {
    label: 'Property Size',
    getValue: (data: DecaturData) => {
      const acres = getData(data, 'acres', null);
      return acres ? `${acres} acres` : 'No property size information available';
    }
  },
  {
    label: 'Deed Type',
    getValue: (data: DecaturData) => getData(data, 'deedType', 'No deed type available')
  },
  {
    label: 'GIS Map',
    getValue: (data: DecaturData) => {
      if (data?.mapLink) {
        return `[View in GIS](${data?.mapLink})`;
      }
      return 'No GIS map available';
    }
  },
  {
    label: 'Property Card',
    getValue: (data: DecaturData) => {
      if (data?.propertyCardLink) {
        return `[View Property Card](${data?.propertyCardLink})`;
      }
      return 'No property card available';
    }
  },
  {
    label: 'Tax Bill',
    getValue: (data: DecaturData) => {
      if (data?.taxBillLink) {
        return `[View Tax Bill](${data?.taxBillLink})`;
      }
      return 'No tax billl available';
    }
  },
  {
    label: 'Property Photo',
    getValue: (data: DecaturData) => {
      if (data?.imageLink) {
        return `[View Property Photo](${data?.imageLink})`;
      }
      return 'No property photo available';
    }
  }
];

export const formatDecaturData = (data: DecaturData): string => {
  return formatTableData(data, DECATUR_ROWS);
};
